module.exports = __webpack_public_path__ + "assets/3bca485ceb1fb4524dea76223644a2f8.png";